import { useLanguage } from '../LanguageContext';
import React from 'react';
import { NavLink } from 'react-router-dom';
import axiosInstance from '../axiosInstance';
import { useBranding } from '../BrandingContext';

const NavBar = ({ role, setRole = () => {}, setShowNavbar = () => {} }) => {
  const { t, language, setLanguage } = useLanguage();
  const { branding } = useBranding();
  
  const handleLogout = async () => {
    try {
      // ✅ Ensure setRole and setShowNavbar exist before calling them
      if (typeof setRole !== "function" || typeof setShowNavbar !== "function") {
        console.error("❌ setRole or setShowNavbar is not a function. Cannot proceed with logout.");
        return;
      }
  
      // ✅ Call the logout API
      const response = await axiosInstance.post('/api/logout', {}, { withCredentials: true });
  
      if (response.data.success) {
        console.log("✅ Logout successful:", response.data.message);
  
        // ✅ Clear local authentication state
        setRole("guest");
        setShowNavbar(false);
  
        // ✅ Force cookie removal (ensures session is fully cleared)
        document.cookie = "access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=grafana.avonde.fr";
  
        // ✅ Force an auth refresh before redirecting
        await axiosInstance.get('/api/check-auth', { withCredentials: true })
          .catch(err => console.warn("🔍 Auth check confirms user is logged out:", err.response?.data || err));
  
        // ✅ Force hard reload and redirect
        setTimeout(() => {
          window.location.href = "/login";
        }, 100);
      } else {
        console.error("❌ Logout failed:", response.data.error);
      }
    } catch (err) {
      console.error("❌ Logout request error:", err);
    }
  };
  

  const links = [
    { path: '/player-list', label: t("Player List"), roles: ['moderator', 'admin', 'superadmin'] },
    { path: '/banned-players', label: t("Banned Players"), roles: ['moderator', 'admin', 'superadmin'] },
    { path: '/manual-bans', label: t("Manual Ban & Kick"), roles: ['moderator', 'admin', 'superadmin'] }, 
    { path: '/admin', label: t("Admin Dashboard"), roles: ['admin', 'superadmin'] },
    { path: '/appearance', label: t("Site appearance"), roles: ['superadmin'] },
    { action: 'logout', label: t("Logout"), roles: ['moderator', 'admin', 'superadmin'] }
  ];
  

  return (
    <nav className="navbar" aria-label={t("Main navigation")}>
      <div className="brand">{branding.logo ? <img className="brand-logo" src={branding.logo} alt={`${branding.name} logo`} /> : <span className="brand-mark" aria-hidden="true">{'//'}</span>}<div>{branding.name}<small>{branding.description}</small></div></div>
      <ul className="nav-links">
        <li><select className="language-select" aria-label="Langue / Language" value={language} onChange={event => setLanguage(event.target.value)}>
          <option value="fr">Français</option><option value="en">English</option>
        </select></li>
        {links.filter(link => link.roles.includes(role)).map(link => <li key={link.label}>
          {link.action === 'logout' ? <button className="logout-button" onClick={handleLogout}>{t("Log out")}</button> :
            <NavLink to={link.path} className={({ isActive }) => isActive ? 'nav-link active' : 'nav-link'}>{link.label}</NavLink>}
        </li>)}
      </ul>
    </nav>
  );
};

export default NavBar;
